import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-repository-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { AzureDevopsIcon, AzureDevopsSearchResultIcon } from './icon';

export const azureDevopsConfig: ThirdPartyConfig = {
	displayName: 'Azure DevOps',
	id: 'azure-devops',
	resourceType: ProductResourceTypes3P.AzureDevops,
	icon: get3PLogo(AzureDevopsIcon, 'AzureDevOps', 'medium'),
	searchResultIcon: get3PLogo(AzureDevopsSearchResultIcon, 'AzureDevOps', 'large'),
	integrationAri: 'ari:cloud:platform::integration/azure-devops',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Repository,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Repository],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: true,
	isEnabled: () => true,
};
